export default __webpack_public_path__ + "static/media/Icon10_On.84e25031.png";